import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { HomePageState } from '../../../containers/home/states/HomePageState';
import { groupByDate, Reservable, ReservableType } from '../../../../commonv3/types/reservable';
import { DateGroup } from '../../molecules/reservable/DateGroup';
import { ScheduleListItem } from '../../molecules/reservable/ScheduleListItem';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { Confirmation } from '../../molecules/modals/Confirmation';
import { Pane, PaneHeader } from '../../molecules/mypage/page';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { BackButtonHeader } from './BackButtonHeader';
import { V3Routes } from '../../../routes';
import { LoaderRow } from '../../atoms/layout/LoaderRow';
import { TrialLessonCancellationPolicy } from '../../molecules/reservations/TrialLessonCancellationPolicy';
import { TrialLessonCancelConfirmation } from '../../molecules/modals/TrialLessonCancelConfirmation';
import { CancelStep, ReservationListState } from '../home/states/ReservationListState';
import { TokenType } from '../../../../commonv3/types/tokens';
import { MulticreatorScheduleListItem } from '../../molecules/reservable/MulticreatorScheduleListItem';
import {ReservationCancelSurveyShowPage} from "../../../containers/surveys/ReservationCancelSurveyPage";
import {OverlayPage} from "../../../../commonv3/components/molecules/layout/OverlayPage"

type DialogProps = {
    reservationList: ReservationListState;
};

export function isMulticreatorSession(session: Reservable) {
    return session.required_token_type === TokenType.MULTICREATOR;
}

const CancelDialogs = observer(({ reservationList }: DialogProps) => {
    const {
        cancelDialog,
        confirmCancel,
        processingState,
        submitting,
        requestRescheduleTrialReservation,
        cancellingReservation,
        cancelStep,
        cancelFormState,
        submitCancel,
    } = reservationList;
    if (!cancellingReservation) {
        return null;
    }
    switch (cancelStep) {
        case CancelStep.CONFIRMATION:
            return cancellingReservation.reservable_type === ReservableType.TRIAL_LESSON ? (
                <TrialLessonCancelConfirmation
                    headerMessage="本当にキャンセルしますか？"
                    message={
                        <TrialLessonCancellationPolicy
                            showRescheduleInformation={true}
                            showMypageLink={false}
                            lesson={cancellingReservation.reservable}
                        />
                    }
                    confirmationText="キャンセルする"
                    rescheduleButtonText={
                        cancellingReservation.reservable.location ? 'WEB体験に振り替える' : '他の枠に振り替える'
                    }
                    open={cancelDialog.isOpen}
                    onReschedule={requestRescheduleTrialReservation}
                    onAbort={cancelDialog.close}
                    onConfirmation={confirmCancel}
                    loading={processingState.submitting}
                />
            ) : (
                <Confirmation
                    id="cancel-confirmation"
                    headerMessage="本当にキャンセルしますか？"
                    message={'この操作は取り消しできません。'}
                    confirmationText="キャンセルする"
                    open={cancelDialog.isOpen}
                    onAbort={cancelDialog.close}
                    onConfirmation={confirmCancel}
                    loading={processingState.submitting}
                />
            );
        case CancelStep.FORM:
            return (
                <OverlayPage
                    id="cancel-form"
                    open={cancelDialog.isOpen}
                    onRequestClose={cancelDialog.close}
                >
                    <ReservationCancelSurveyShowPage reservationId={reservationList.cancellingReservationId}/>
                </OverlayPage>
            );
    }
});

type Props = {
    homeState: HomePageState;
};

@inject('homeState')
@observer
export class ReservationListPane extends React.Component<Props> {
    render() {
        const { reservationList } = this.props.homeState;
        const { loading, allReservationList, requestCancel } = reservationList;
        const groups = groupByDate(allReservationList, (r) => r.reservable.starts_at);
        return (
            <Pane activeMenu={'reservations'} id="reservation-list-pane">
                {GlobalStatesV3.viewport.isMobile && <BackButtonHeader to={V3Routes.myPage()} />}
                <PaneHeader>予約一覧</PaneHeader>
                {loading && <LoaderRow />}
                {groups.map((g) => {
                    return (
                        <DateGroup key={g.date} date={g.date}>
                            {g.entries.map((entry) => {
                                if (isMulticreatorSession(entry.reservable)) {
                                    return (
                                        <MulticreatorScheduleListItem
                                            id={`reservation-item-${entry.reservable_type}-${entry.reservable.id}`}
                                            key={entry.id}
                                            title={entry.reservable.title}
                                            reservable={entry.reservable}
                                        />
                                    );
                                } else {
                                    return (
                                        <ScheduleListItem
                                            id={`reservation-item-${entry.reservable_type}-${entry.reservable.id}`}
                                            key={entry.id}
                                            title={entry.reservable.title}
                                            reservable={entry.reservable}
                                            actionItem={
                                                <Button
                                                    type="normal"
                                                    size="m"
                                                    disabled={false}
                                                    onClick={() => requestCancel(entry)}
                                                    id={`cancel-button-${entry.reservable_type}-${entry.reservable.id}`}
                                                >
                                                    キャンセル
                                                </Button>
                                            }
                                        />
                                    );
                                }
                            })}
                        </DateGroup>
                    );
                })}
                <CancelDialogs reservationList={reservationList} />
            </Pane>
        );
    }
}
